export const APP_SCOPES = [
  'app:integrations:read',
  'app:integrations:write',
  'aut:emails:read',
  'aut:emails:write',
  'aut:keyset:read',
  'aut:keyset:write',
  'aut:mirror:read',
  'aut:mirror:write',
  'aut:pos:read',
  'aut:pos:write',
  'aut:rules:read',
  'aut:rules:write',
  'cat:channel:read',
  'cat:channel:write',
  'cat:prices:read',
  'cat:prices:write',
  'cnt:files:read',
  'cnt:files:write',
  'qcq:proxies:read',
  'qcq:proxies:write',
  'rel:contacts:read',
  'rel:contacts:write',
  'iam:2fa:write',
  'iam:customer:read',
  'iam:customer:write',
  'iam:logs:read',
  'iam:roles:read',
  'iam:roles:write',
  'iam:sources:read',
  'iam:sources:write',
  'iam:tenants:write',
  'iam:users:write',
  'int:registrations:read',
  'int:registrations:write',
  'cnt:instant:read',
  'cnt:instant:write',
  'mes:buckets:read',
  'mes:buckets:write',
  'odr:businesses:read',
  'odr:businesses:write',
  'odr:inventory:read',
  'odr:inventory:write',
  'odr:locations:read',
  'odr:locations:write',
  'odr:coupons:read',
  'odr:coupons:write',
  'odr:methods:read',
  'odr:payment-methods:read',
  'odr:payment-methods:write',
  'odr:product:read',
  'odr:supply:read',
  'odr:supply:update',
  'odr:businesses:read',
  'odr:businesses:write',
  'odr:locations:read',
  'odr:locations:write',
  'odr:points:read',
  'odr:points:write',
  'odr:rules:read',
  'odr:rules:write',
  'odr:shipping-methods:read',
  'odr:shipping-methods:write',
  'odr:supply:read',
  'odr:supply:update',
  'odr:zones:read',
  'odr:zones:write',
  'odr:orders:read',
  'odr:orders:write',
  'odr:product:read',
  'odr:routing:read',
];

export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
